export const LISTE_PARAMETRAGE_EDITION = {
  title: 'Liste des paramètres d\'éditions',
  breadcrumb: {
    racine: 'Accueil',
    parametrage: 'Paramétrage',
    liste: 'Liste des paramètres d\'éditions',
  },
  actions: {
    add: 'Ajouter un paramètre d\'édition',
    search: 'Rechercher',
    edit: 'Modifier',
    delete: 'Supprimer',
    archiver: 'Archiver',
  },
  tab: {
    typeEdition: 'Type d\'édition',
    afficherLogo: 'Affichage du logo',
    afficherPiedPage: 'Afficher pied de page',
    margeHaut: 'Marge du haut (mm)',
    margeBas: 'Marge du bas (mm)',
    margeGauche: 'Marge de gauche (mm)',
    margeDroite: 'Marge de droite (mm)',
  },
  yes: 'Oui',
  no: 'Non',
};

export const ADD_PARAMETRAGE_EDITION = {
  titleAdd: 'Ajouter un paramètre d\'édition',
  titleEdit: 'Modifier un paramètre d\'édition',
  actions: {
    cancel: 'Annuler',
  },
  error: {
    problemOccurred: 'Un problème est survenu',
    oneTypePerCompany: 'Le paramétrage existe déjà dans la société',
    champs: {
      editionType: 'Type d\'édition',
      margeHaut: 'Marge du haut',
      margeBas: 'Marge du bas',
      margeGauche: 'Marge de gauche',
      margeDroite: 'Marge de droite',
    },
  },
  informationParametrage: {
    typeEdition: 'Type édition',
    afficherLogo: 'Afficher logo',
    afficherPiedPage: 'Afficher pied de page',
    margeHaut: 'Marge du haut (mm)',
    margeBas: 'Marge du bas (mm)',
    margeDroite: 'Marge de droite (mm)',
    margeGauche: 'Marge de gauche (mm)',
  },
  editionListe: {
    facture: 'Facture',
    devis: 'Devis',
    commande: 'Commande',
    remiseBancaire: 'Remise bancaire',
    relance: 'Relance',
    produitReseau: 'Produit réseau',
    ordreTravail: 'Ordre de travail',
    lotPaiementChequeManuel: 'Lot paiement chèque manuel',
    lotPaiementLettreCheque: 'Lot paiement lettre chèque',
    lotPaiementVirement: 'Lot paiement virement',
    justifPose: 'Justif pose',
    dossierTempo: 'Dossier tempo',
    etiquette: 'Etiquette facture',
  },
  success: {
    add: 'Le paramétrage de l\'édition a été ajouté avec succès',
    edit: 'Le paramétrage de l\'édition a été modifié avec succès',
  },
};
